import type { IBIReporterService, OperationDurationParams } from 'root/services/biReporterService';
import { dispatchState } from 'root/states/DispatchState';
import { type ItemState } from 'root/states/itemsState';
import { type MenusState } from 'root/states/MenusState';
import type { Operation } from 'root/types/businessTypes';

export function getOperationDurationParamsByOperationId(
  operationId: string | undefined,
  operation?: Operation
) {
  const baseOperationDurationParams = { isSSRCall: false };
  if (!operationId) {
    return baseOperationDurationParams;
  }
  const _operation = operation || dispatchState.operations.find((o) => o.id === operationId);
  return {
    ...baseOperationDurationParams,
    operationId,
    operationName: _operation?.name,
    locationId: _operation?.locationId,
    operationGroup: _operation?.operationGroupId,
    isDefaultLocation: _operation?.locationDetails?.default,
  };
}

export function getMenusBIFields(menusState: MenusState, itemsState: ItemState) {
  return {
    menusQuantity: menusState.menus.length,
    sectionsQuantity: menusState.sectionsSize,
    itemsQuantity: menusState.size,
    modifiersQuantity: itemsState.modifiersQuantity,
    variantsQuantity: itemsState.variantsQuantity,
    labelsQuantity: itemsState.labelsQuantity,
  };
}

export function getOperationBIEventSettings(
  menusState: MenusState,
  itemsState: ItemState,
  biReporterService?: IBIReporterService,
  isSSRCall: boolean = false,
  useSSRCache: boolean = false
) {
  const monitorBiEvent = biReporterService?.reportOperationDurationBiEvent as unknown as (
    params: unknown
  ) => void;

  const operationDurationParams: OperationDurationParams = {
    isSSRCall,
    useSSRCache,
    operationId: dispatchState.operationId,
    operationName: dispatchState.currentOperation?.name,
    locationId: dispatchState.locationId,
    operationGroup: dispatchState.currentOperation?.operationGroupId,
    isDefaultLocation: dispatchState.currentOperation?.locationDetails?.default,
    extraFields: getMenusBIFields(menusState, itemsState),
  };
  return { monitorBiEvent, params: operationDurationParams };
}
